var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalAssets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3777_13154)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#004988"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6002 77.5311H37.4395L38.4734 75.3326C38.9688 74.279 39.2002 73.2842 39.2002 72.3064C39.2002 71.3073 38.9585 70.2737 38.4394 69.1656L36.1755 64.332H68.0002V23.4149C68.0002 22.4925 67.162 21.8546 66.3773 22.1796L57.2579 25.957L48.0185 22.1777C47.7444 22.0656 47.4426 22.0674 47.1697 22.1828L38.1679 25.988L28.8171 22.1772C28.0333 21.8578 27.2002 22.4955 27.2002 23.4149V68.2918C27.2002 73.3945 30.961 77.5311 35.6002 77.5311ZM37.9999 37.9309H47.5999C48.2626 37.9309 48.7999 38.5219 48.7999 39.2508C48.7999 39.9798 48.2626 40.5708 47.5999 40.5708H37.9999C37.3371 40.5708 36.7999 39.9798 36.7999 39.2508C36.7999 38.5219 37.3371 37.9309 37.9999 37.9309ZM57.1999 48.4962H37.9999C37.3371 48.4962 36.7999 49.0872 36.7999 49.8161C36.7999 50.5451 37.3371 51.136 37.9999 51.136H57.1999C57.8626 51.136 58.3999 50.5451 58.3999 49.8161C58.3999 49.0872 57.8626 48.4962 57.1999 48.4962ZM76.4495 73.5655C76.4495 69.9632 73.8255 67.035 70.5652 66.9672H39.2001C41.1693 69.1346 42.2209 71.3352 42.2248 73.6125C42.2287 75.8891 41.1851 78.0576 39.2238 80.1651H70.4495C73.7632 80.1651 76.4495 77.2104 76.4495 73.5655Z",
    fill: "#004988"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3777_13154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalAssets);
export default __webpack_public_path__ + "static/media/digitalAssets.1aaa9c861d4a99ab2266c51aa975ba86.svg";
export { ForwardRef as ReactComponent };